import { ActivityMetaType, type ActivityMeta } from '@/models/Activity';

export const readActivityMetaMap: Record<number, ActivityMeta> = {
  40040: {
    name: 'Magazine',
    type: ActivityMetaType.read,
    icon: 'book-open',
  },
  40050: {
    name: 'Go!',
    type: ActivityMetaType.read,
    icon: 'book-open',
  },
  40053: {
    name: 'How-To',
    type: ActivityMetaType.read,
    icon: 'list-check',
  },
  40054: {
    name: 'Smart Info',
    type: ActivityMetaType.read,
    icon: 'book-open',
  },
  40056: {
    name: 'Smart Model',
    type: ActivityMetaType.read,
    icon: 'book-open',
  },
  40059: {
    name: 'Smart Image',
    type: ActivityMetaType.read,
    icon: 'book-open',
  },
  40157: {
    name: 'How-To',
    type: ActivityMetaType.read,
    icon: 'list-check',
  },
  40934: {
    name: 'Meet the Expert',
    type: ActivityMetaType.read,
    icon: 'rocket-launch',
  },
};
